import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow, RadioButton } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

export const StyledRadioButtonContainer = styled(FlexRow)`
    margin-bottom: 16px;
`;

export const StyledDropdownContainer = styled(Stack)`
    display: flex;
    gap: 8px;
    width: 263px;

    & .DropdownButton {
        & .DropdownButton--triangle {
            color: ${colorsPalettes.carbon["400"]};
        }
    }
`;

export const StyledRadioButton = styled(RadioButton)`
    padding: 0 20px 9px 0;
    &:last-child {
        padding-right: 0;
    }

    label {
        margin-left: 4px;
    }
`;

export const StyledDropdownLabel = styled.div`
    display: flex;
    ${setFontVariant("sectionTitle", colorsPalettes.carbon[400])};
`;
